import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrPenIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M10.6525 1C10.4934 1 10.3358 1.03165 10.1891 1.0931C10.0432 1.15418 9.91084 1.24348 9.79962 1.35588L1.3484 9.8071L1.34729 9.80822C1.23665 9.9194 1.14903 10.0513 1.08944 10.1964C1.03002 10.3411 0.999628 10.496 1 10.6524V13.8001C1 14.1184 1.12642 14.4235 1.35144 14.6486C1.57646 14.8736 1.88165 15 2.19987 15H5.34767C5.50403 15.0004 5.65894 14.97 5.8036 14.9106C5.94869 14.851 6.0806 14.7634 6.19179 14.6527L14.642 6.20243L14.6441 6.20043C14.7565 6.0892 14.8458 5.95683 14.9069 5.81093C14.9684 5.66417 15 5.50664 15 5.34752C15 5.18841 14.9684 5.03088 14.9069 4.88411C14.8458 4.73823 14.7565 4.60586 14.6441 4.49463L14.642 4.49262L11.5074 1.35795L11.5053 1.35588C11.3941 1.24348 11.2618 1.15418 11.1159 1.0931C10.9691 1.03165 10.8116 1 10.6525 1ZM9.20041 3.755L10.6525 2.30293L13.6971 5.34752L12.245 6.79959L9.20041 3.755ZM8.30045 4.65495L11.345 7.69955L5.31733 13.7273H2.27273V10.6827L8.30045 4.65495Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrPenIconComponent;
